import React from "react";
import { useEffect, useState } from "react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
const PayrollActiveUserModal = ({
  filteredUsers,
  handleAddRow,
  searchTerm,
  setSearchTerm,
}) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <div style={styles.dropdownMainBox}>
      <li key="search" disabled style={styles.inputParent}>
        <input
          // placeholder="Search"
          placeholder={t("Search")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.input}
        />
      </li>
      {filteredUsers.map((user, index) => (
        <li
          key={`${user.id}-${index}`}
          onClick={() => handleAddRow(user)}
          style={{ gap: "0.5rem", padding: "4px 8px" }}
          className="team-add-work-single-user-div frc"
        >
          {user?.imageurl ? (
            <img alt="" src={user.imageurl} style={styles.profileImage} />
          ) : (
            <div style={styles.profileAbv} className="team-add-work-user-img">
              {user?.firstname?.[0]}
            </div>
          )}
          <span>{user.firstname}</span>{" "}
        </li>
      ))}
    </div>
  );
};

export default PayrollActiveUserModal;

const styles = {
  dropdownMainBox: {
    maxHeight: "15rem",
    overflow: "auto",
    backgroundColor: "white",
    filter: "drop-shadow(0px 6px 12px #2D2E1C1A)",
    borderRadius: "4px",
  },
  inputParent: {
    position: "sticky",
    top: 0,
    left: 0,
    backgroundColor: "#FFFFFF",
    padding: "4px 8px",
    display: "flex",
    flexDirection: "row",
    columnGap: "0.5rem",
  },
  input: {
    width: "100%",
    border: "0.5px solid #475757",
    borderRadius: "8px",
    padding: " 5px",
  },
  profileImage: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  profileAbv: { width: "30px", height: "30px" },
};
